import { createSlice } from '@reduxjs/toolkit';

import {
  getTypers,
  createTyper,
  updateTyper,
  deleteTyper,
} from './middleware';

const initialState = {
  typers: [],
  error: '',
};

export const typersSlice = createSlice({
  name: 'typers',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload.error;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTypers.fulfilled, (state, action) => {
      state.typers = action.payload;
    });
    builder.addCase(updateTyper.fulfilled, (state, action) => {
      const idx = state.typers.findIndex((t) => t.id === action.payload.id);
      if (idx !== -1) {
        state.typers[idx] = action.payload;
      }
    });
  },
});

export {
  getTypers,
  createTyper,
  updateTyper,
  deleteTyper,
};

export const { setError } = typersSlice.actions;

export default typersSlice.reducer;
